import { Routes } from '@angular/router'
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component'

// Panel routes (customer/workshop/driver/website) are added incrementally
// here, one loadChildren entry at a time, as each panel is ported during
// Phase 2 of the Angular 22 migration -- see the migration plan.
export const routes: Routes = [
    {
        path: 'customer',
        loadChildren: () => import('./customer-panel/customer-panel.module')
            .then(mod => mod.CustomerPanelModule)
    },
    {
        path: 'workshop',
        loadChildren: () => import('./workshop-panel/workshop-panel.module')
            .then(mod => mod.WorkshopPanelModule)
    },
    {
        path: 'driver',
        loadChildren: () => import('./driver-panel/driver-panel.module')
            .then(mod => mod.DriverPanelModule)
    },
    {
        path: '',
        loadChildren: () => import('./website/website.module')
            .then(mod => mod.WebsiteModule)
    },
    {
        path: '**',
        component: PageNotFoundComponent,
        data: { message: 'From ROOT' }
    }
]
